import type { DocVStatus } from '@Store/slices/ubo/createUboSlice';

export enum AuthUserOnboardingStatus {
  DURING_REGISTRATION = 'DURING_REGISTRATION',
  KYC_PASSED = 'KYC_PASSED',
  KYC_FIRST_FAILED = 'KYC_FIRST_FAILED',
  KYC_FAILED_FINAL = 'KYC_FAILED_FINAL',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
}

export enum InviteStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  RE_INVITED = 'RE_INVITED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}

export enum AuthorizedUserType {
  ACCOUNTANT = 'ACCOUNTANT',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  EMPLOYEE = 'EMPLOYEE',
}

export enum AuthorizedUserOnboardingType {
  AUTHORIZEDUSER_KYC = 'AUTHORIZEDUSER_KYC',
  AUTHORIZEDUSER_NOKYC = 'AUTHORIZEDUSER_NOKYC',
  NOT_NEEDED = 'NOT_NEEDED',
  KYC_ONLY = 'KYC_ONLY',
}

export enum AccountantPermissionLevel {
  VIEW_ONLY = 'VIEW_ONLY',
  EDITOR = 'EDITOR',
  BILL_PAYER = 'BILL_PAYER',
}

export interface IAuthUserDocVData {
  url?: string;
  qrCode?: string;
  status: DocVStatus;
}

export interface IAuthUserLastStep {
  step: number;
  version: string;
  stepName: string;
}

export interface IAuthCustomer {
  customerId: string;
  customerFirstName: string;
  customerLastName: string;
  authorizedUserFullName: string;
  customerBusinessName: string;
  inviteStatus: InviteStatus;
  authorizedUserType: AuthorizedUserType;
  accessToken?: string;
  consentFormData?: string | Blob | null;
  authorizedUserId?: string;
  accountantEmail?: string;
  accountantName?: string;
  isExistingUser?: boolean;
  isUsFlow?: boolean;
  docVData?: IAuthUserDocVData | null;
  lastStepData?: IAuthUserLastStep | null;
  onboardingType?: AuthorizedUserOnboardingType;
  accountantPermissionLevel?: AccountantPermissionLevel;
}

export interface IAuthOnboardingSlice {
  authOnboardingSlice: IAuthCustomer;
  setAuthOnboardingData: (data: IAuthCustomer) => void;
  getAuthUserType: () => AuthorizedUserType;
  getOnboardingType: () => AuthorizedUserOnboardingType | undefined;
  getAuthUserAccessToken: () => string;
  setAuthUserAccessToken: (token: string) => void;
  setConsentFormData: (formData: string | Blob) => void;
  getConsentFormData: () => string | Blob | null;
  setAuthUserIsUsFlow: (isUs: boolean) => void;
  getAuthUserIsUsFlow: () => boolean;
  setAuthUserDocVData: (data: IAuthUserDocVData) => void;
  getAuthUserDocVData: () => IAuthUserDocVData | null;
  getAccountantPermissionLevel: () => AccountantPermissionLevel | undefined;
}
